import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import AppViewSheetBreadcrumb from "@/v2-backoffice-client/app/AppViewSheetBreadcrumb"
import Tabs from "@/v2-backoffice-client/components/tabs"
import FeatureAvailabilityTab from "@/v2-backoffice-client/feature/availability/FeatureAvailabilityTab"
import { FEATURE_TAB } from "@/v2-backoffice-client/feature/feature.constants"
import { useNavLayerViewQuery } from "@/v2-backoffice-client/navlayer/view/navlayer.view.query"
import NavLayerViewDetails from "@/v2-backoffice-client/navlayer/view/NavLayerViewDetails"
import NavLayerViewInfo from "@/v2-backoffice-client/navlayer/view/NavLayerViewInfo"
import NavLayerViewToolbar from "@/v2-backoffice-client/navlayer/view/NavLayerViewToolbar"
import NavLayerUpdateEditor from "@/v2-backoffice-client/navlayer/update/NavLayerUpdateEditor"
import {
  NAV_LAYER_VIEW_DEFAULT_TAB,
  NAV_LAYER_VIEW_TABS_ID,
} from "@/v2-backoffice-client/navlayer/navlayer.constants"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"

function NavLayerViewSheet() {
  const { id } = useAppViewSheetOpener()
  const featureCode = String(id)

  const { data, loading, error } = useNavLayerViewQuery({
    skip: !featureCode,
    variables: { featureCode },
  })

  const navLayer = data?.getNavLayerByFeatureCode

  return (
    <>
      <ViewSheet.Header>
        <AppViewSheetBreadcrumb />
        <ViewSheet.Title isLoading={loading}>
          {navLayer?.Name ?? navLayer?.FeatureCode}
        </ViewSheet.Title>
      </ViewSheet.Header>

      <ViewSheet.HeaderRow>
        <NavLayerViewInfo navLayer={navLayer} isLoading={loading} />
        <NavLayerViewToolbar navLayer={navLayer} />
      </ViewSheet.HeaderRow>

      <Tabs
        id={NAV_LAYER_VIEW_TABS_ID}
        defaultValue={NAV_LAYER_VIEW_DEFAULT_TAB}
        isLoading={loading}
        error={error}
        isEmpty={!navLayer}
        emptyLabel="Nav layer not found."
      >
        <Tabs.List>
          <Tabs.Trigger value={FEATURE_TAB.details}>Details</Tabs.Trigger>
          <Tabs.Trigger value={FEATURE_TAB.configuration}>
            Configuration
          </Tabs.Trigger>
          <Tabs.Trigger value={FEATURE_TAB.availability}>
            Availability
          </Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value={FEATURE_TAB.details} className="flex-1">
          {navLayer && <NavLayerViewDetails navLayer={navLayer} />}
        </Tabs.Content>

        <Tabs.Content value={FEATURE_TAB.configuration} className="flex-1">
          <NavLayerUpdateEditor navLayer={navLayer} />
        </Tabs.Content>

        <Tabs.Content value={FEATURE_TAB.availability} className="flex-1">
          {navLayer && (
            <FeatureAvailabilityTab
              featureCode={navLayer.FeatureCode}
              subject="nav layer"
              featureCodeLabel="NavLayers"
            />
          )}
        </Tabs.Content>
      </Tabs>
    </>
  )
}

export default NavLayerViewSheet
